import * as React from 'react';

import { requestDelete } from '../../../../modules/request/index';
import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility'

interface LeaveClassModalProps {
  close: () => void;
  onSuccess: (string) => void;
  classroom: any;
}

const LeaveClassModal = ({ close, onSuccess, classroom, }: LeaveClassModalProps) => {
  const { modalRef, } = useModalAccessibility(close)

  function leaveClass() {
    requestDelete(`/classrooms_teachers/destroy/${classroom.id}`, null, () => {
      onSuccess('Left class')
      close()
    })
  }

  return (
    <div className="modal-container leave-class-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="leaveClassModalTitle"
        aria-modal={true}
        className="leave-class-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div>
          <h3 className="title" id="leaveClassModalTitle">Leave class?</h3>
        </div>
        <div className="leave-class-modal-text">
          <p>You won't be able to view or manage this class unless you're re-invited.</p>
        </div>
        <div className="form-buttons">
          <button className="quill-button outlined green medium focus-on-light" onClick={close}>Cancel</button>
          <button className="quill-button contained green medium focus-on-light" onClick={leaveClass}>Leave class</button>
        </div>
      </div>
    </div>
  )
}

export default LeaveClassModal
